import { render, staticRenderFns } from "./CustomerAccountDetailView.vue?vue&type=template&id=74a9d621"
import script from "./CustomerAccountDetailView.vue?vue&type=script&lang=js"
export * from "./CustomerAccountDetailView.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccountDetailView.vue?vue&type=style&index=0&id=74a9d621&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports